import getValueByPath from '../../get-value-by-path';
/**
 * Sorts an array of objects alphabetically based on a property path.
 *
 * @param {Array} arr The array to sort.
 * @param {String} path The dot-separated path to the property to sort by.
 *
 * @return {Array} The sorted array.
 *
 * @example
 * const arr = [{name: {first: 'John'}}, {name: {first: 'Jane'}}];
 * sortAlphabetically(arr, 'name.first');
 * // Returns: [{name: {first: 'Jane'}}, {name: {first: 'John'}}]
 */
const sortAlphabetically = ( arr, path ) => {
	// Use the Array.prototype.sort() function to sort the array in place.
	return arr.sort( ( a, b ) => {
		const aValue = getValueByPath( a, path );
		const bValue = getValueByPath( b, path );

		// Handle undefined values
		// If 'a' is undefined, sort 'a' last
		if ( typeof aValue === 'undefined' ) {
			return 1;
		}

		// If 'b' is undefined, sort 'b' last
		if ( typeof bValue === 'undefined' ) {
			return -1;
		}

		// Convert the values to strings and to lower case for case-insensitive comparison.
		let aString = String( aValue ).toLowerCase();
		let bString = String( bValue ).toLowerCase();

		// Remove the '{' and '}' characters from the strings.
		aString = aString.replace( /[{}]/g, '' );
		bString = bString.replace( /[{}]/g, '' );

		// Use the String.prototype.localeCompare() method to compare the strings alphabetically.
		return aString.localeCompare( bString );
	} );
}

export default sortAlphabetically;
